import HomePage from "../pages/home/HomePage";
import { RouteType } from "./config";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Bidimensional from "../pages/Bidimensional";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import Teste from "../pages/branqueamento/Teste";
import Tridimensional from "../pages/branqueamento/Tridimensional";

const appRoutes: RouteType[] = [
  {
    index: true,
    element: <HomePage />,
    state: "home"
  },
  {
    path: "home",
    element: <HomePage />,
    state: "home",
    sidebarProps: {
      displayText: "Início",
      icon: <AccountBalanceIcon />
    }
  },
  {
    path: "videos/:filename",
    element: <HomePage />,
    state: "homeP"
  },
  {
    path: "Bidimensional",
    element: <Bidimensional />,
    state: "bidimensional",
    sidebarProps: {
      displayText: "Bidimensional",
      icon: <ArticleOutlinedIcon />
    }
  },
  {
    path: "3D",
    element: <Teste />,
    state: "teste",
    sidebarProps: {
      displayText: "Visualizar 3D",
      icon: <ArticleOutlinedIcon />
    }
  },
  {
    path: "TESTE3D",
    element: <Tridimensional />,
    state: "teste3D",
    sidebarProps: {
      displayText: "TESTE Visualizar 3D",
      icon: <ArticleOutlinedIcon />
    }
  }
];

export default appRoutes;